export const TipoAsegurado = {
    ASEGURADO_PRINCIPAL: 'AseguradoPrincipal',
    ASEGURADO_SECUNDARIO: 'AseguradoSecundario'       
}